import { fetchClientApiStep } from '../clientApiStep.helpers';

// eslint-disable-next-line import/prefer-default-export
export const fetchClientApiSolar = async ({ api, body, submissionId, token }) =>
  fetchClientApiStep({
    api,
    body,
    submissionId,
    token,
    label: 'Solar potential',
  });
